import { render, staticRenderFns } from "./UserInfoShow.vue?vue&type=template&id=64e60830&"
import script from "./UserInfoShow.vue?vue&type=script&lang=js&"
export * from "./UserInfoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports